// Full KPI set for detailed views
export const kpisData = {
  2024: {
    productionVsPlan: { value: 88, unit: "%", vsBudget: -12, vsPrevious: null, status: "attention" },
    oreProcessed: { value: 2.4, unit: "Mt", vsBudget: -8, vsPrevious: null, status: "attention" },
    recoveryRate: { value: 92.1, unit: "%", vsBudget: 1.1, vsPrevious: null, status: "strong" },
    revenue: { value: 245, unit: "M USD", vsBudget: -5, vsPrevious: null, status: "inline" },
    ebitda: { value: 78, unit: "M USD", vsBudget: -3, vsPrevious: null, status: "inline" },
    cashAvailable: { value: 42, unit: "M USD", vsBudget: -15, vsPrevious: null, status: "attention" },
    capexExecution: { value: 76, unit: "%", vsBudget: -24, vsPrevious: null, status: "pressure" },
    headcount: { value: 1842, unit: "", vsBudget: 2, vsPrevious: null, status: "inline" },
    turnoverRate: { value: 8.2, unit: "%", vsBudget: 1.2, vsPrevious: null, status: "attention" },
    criticalRolesFilled: { value: 91, unit: "%", vsBudget: -4, vsPrevious: null, status: "attention" },
    ltifr: { value: 0.42, unit: "", vsBudget: -0.08, vsPrevious: null, status: "strong" },
    environmentalCompliance: { value: 96, unit: "%", vsBudget: 1, vsPrevious: null, status: "strong" },
  },
  2025: {
    productionVsPlan: { value: 94, unit: "%", vsBudget: -6, vsPrevious: 6, status: "attention" },
    oreProcessed: { value: 2.7, unit: "Mt", vsBudget: -3, vsPrevious: 12.5, status: "inline" },
    recoveryRate: { value: 93.4, unit: "%", vsBudget: 2.4, vsPrevious: 1.3, status: "strong" },
    revenue: { value: 298, unit: "M USD", vsBudget: 3, vsPrevious: 21.6, status: "strong" },
    ebitda: { value: 102, unit: "M USD", vsBudget: 8, vsPrevious: 30.8, status: "strong" },
    cashAvailable: { value: 56, unit: "M USD", vsBudget: 5, vsPrevious: 33.3, status: "strong" },
    capexExecution: { value: 87, unit: "%", vsBudget: -13, vsPrevious: 11, status: "attention" },
    headcount: { value: 1956, unit: "", vsBudget: -2, vsPrevious: 6.2, status: "inline" },
    turnoverRate: { value: 6.8, unit: "%", vsBudget: -0.2, vsPrevious: -1.4, status: "inline" },
    criticalRolesFilled: { value: 94, unit: "%", vsBudget: -1, vsPrevious: 3, status: "inline" },
    ltifr: { value: 0.38, unit: "", vsBudget: -0.12, vsPrevious: -0.04, status: "strong" },
    environmentalCompliance: { value: 98, unit: "%", vsBudget: 3, vsPrevious: 2, status: "strong" },
  },
  2026: {
    productionVsPlan: { value: 92, unit: "%", vsBudget: -8, vsPrevious: -2, status: "attention" },
    oreProcessed: { value: 2.5, unit: "Mt", vsBudget: -5, vsPrevious: -7.4, status: "attention" },
    recoveryRate: { value: 94.2, unit: "%", vsBudget: 3.2, vsPrevious: 0.8, status: "strong" },
    revenue: { value: 250, unit: "M USD", vsBudget: 4.2, vsPrevious: 2.0, status: "strong" },
    ebitda: { value: 118, unit: "M USD", vsBudget: 12, vsPrevious: 15.7, status: "strong" },
    cashAvailable: { value: 48, unit: "M USD", vsBudget: -8, vsPrevious: -14.3, status: "attention" },
    capexExecution: { value: 82, unit: "%", vsBudget: -18, vsPrevious: -5, status: "attention" },
    headcount: { value: 2012, unit: "", vsBudget: 1, vsPrevious: 2.9, status: "inline" },
    turnoverRate: { value: 7.5, unit: "%", vsBudget: 0.5, vsPrevious: 0.7, status: "attention" },
    criticalRolesFilled: { value: 92, unit: "%", vsBudget: -3, vsPrevious: -2, status: "attention" },
    ltifr: { value: 0.35, unit: "", vsBudget: -0.15, vsPrevious: -0.03, status: "strong" },
    environmentalCompliance: { value: 97, unit: "%", vsBudget: 2, vsPrevious: -1, status: "strong" },
  },
};
